import * as actions from '../actions/actionTypes';
import initialState from './initialState';

/**
 * This reducer handles the LOAD_ANALYTICS_REIT_SUCCESS action and sets an array of REITs  in the store
 * @param {Array} [state] The REITs  currently in the store, or the initial state
 * @param {Object} action The action to be handled
 * @returns {Array} The REITs
 */
export default function analyticsREITDropdown(
  state = initialState.analyticsREITs,
  action
) {
  switch (action.type) {
    case actions.LOAD_ANALYTICS_REIT_SUCCESS:
      return action.analyticsREITs;
    case actions.UNLOAD_CLIENT:
      return initialState.analyticsREITs;
    default:
      return state;
  }
}
